import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 MÉTHODE REHAB 360™',
  ideal: 'Professionnels et particuliers souhaitant gérer la rééducation via une méthode clinique visuelle.',
  was: '38 €',
  now: '19',
  features: ['6 Volumes Complets', 'Protocoles Épaule, Genou, Cheville, Dos, Hanche et Bras', 'Cadres réels de retour au sport', '5 Bonus Gratuits inclus', 'Garantie de remboursement de 7 jours', '♾️ Accès à vie et mises à jour gratuites'],
  cta: 'Obtenir la méthode Rehab 360™'
};
const trust = [{
  icon: LockIcon,
  label: 'Paiement 100% sécurisé'
}, {
  icon: ZapIcon,
  label: 'Accès instantané'
}, {
  icon: CreditCardIcon,
  label: 'Crédit / Débit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Tarif" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-118" data-mp="3vzp6bk9ecea2">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-119" data-mp="4smdyphto1y9">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-120" data-mp="9tjvczv0cryp">
          <p className="font-display text-xl font-black text-plum" data-id="element-121" data-mp="er1yg9mcgcys">🔥 Offre limitée — Bientôt terminée !</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-122" data-mp="3d9h6bb0zu3y3">
            ⚠️ Ensuite, le prix repasse à 38 €. Ce tarif ne reviendra plus.
          </p>
          <p className="mt-2 inline-flex rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold text-blush-deep" data-id="element-123" data-mp="3i5xx6czkuwev">
            🎟️ Plus que 12 places disponibles à ce prix !
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 py-6 text-center shadow-[0_24px_60px_-28px_rgba(21,128,61,0.45)]" data-id="element-124" data-mp="2uipqbqmi3faq">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-125" data-mp="315weazsl45pl">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-126" data-mp="2w83aueio1pt0">
            <span className="font-semibold text-plum/80" data-id="element-127" data-mp="28hqse9psoao6">Idéal pour :</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-128" data-mp="23j5vok9r494h">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-129" data-mp="23k7fpe8qw5yc">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-130" data-mp="2igy6x089mbcv">
              <span className="relative inline-block font-display leading-none" data-id="element-131" data-mp="2dhd58i1pnowg">
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-132" data-mp="2djg47rkucsdb">
                  {plan.now}
                </span>
                <span className="absolute left-full top-1/2 ml-2 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-133" data-mp="3oycwrbg8hzpf">
                  €
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-134" data-mp="3ng4vw2y0kqxp">
              · Paiement unique · Accès à vie ·
            </p>
            <p className="mt-1 text-[11px] font-medium text-grape" data-id="element-135" data-mp="3rgyh2ok2nrmw">
              Le paiement sera traité dans votre devise locale.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-136" data-mp="o07zdcf4nq5d">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-137" data-mp="a9cv6dfkpx84">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-138" data-mp="e9wot70xuipi" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-139" data-mp="11y6a87u8p4g4">
            <CTAButton size="md" data-id="element-140" data-mp="16qzfqxxj8gt9">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum" data-id="element-141" data-mp="16sadoh4aqucg">
            Vous économisez 137 € (88% de réduction)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-142" data-mp="3a85xblymunkx">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="318iwb19tfjse">
                <Icon className="h-4 w-4 text-grape" data-id="element-144" data-mp="1scj5drrxo71" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-145" data-mp="3szyjawfab8j5" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-146" data-mp="3szox7jxd1liq">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-147" data-mp="3k74x0f1f78vs" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-148" data-mp="3k4sf21vnwyiq">
            <span className="font-display font-bold text-plum" data-id="element-149" data-mp="kkol3zeimngn">
              🛡️ Garantie de Remboursement de 7 Jours.
            </span>{' '}
            Si, au cours des 7 premiers jours, vous estimez que le système ne correspond pas à vos
            besoins, demandez votre remboursement et nous vous rendons 100% de votre argent.
            SIGMA SMART™ s'engage sur vos résultats.
          </p>
        </div>
      </div>
    </section>;
}